import ProfilePicturePlaceholder from '../ProfilePicturePlaceholder/ProfilePicturePlaceholder'
import { truncateAddress } from '@jagad/utils'
import { LIGHT_LAVENDER } from '../../styles/colors'
import { Container, InfoContainer, NameText, AddressText } from './KYCAccountProfileCard.styles'

export type KYCAccountProfileCardProps = {
    name?: string
    address?: string
}

const KYCAccountProfileCard = ({
    name,
    address
}: KYCAccountProfileCardProps) => {
    return (
        <Container>
            <ProfilePicturePlaceholder type="icon" size={40} $backgroundColor={LIGHT_LAVENDER} />
            <InfoContainer>
                {name && <NameText>{name}</NameText>}
                {address && <AddressText>{truncateAddress(address, 12, 12)}</AddressText>}
            </InfoContainer>
        </Container>
    )
}

export default KYCAccountProfileCard
